import { render } from "./ChatPage.vue?vue&type=template&id=1810e656&scoped=true&ts=true"
import script from "./ChatPage.vue?vue&type=script&lang=ts"
export * from "./ChatPage.vue?vue&type=script&lang=ts"

import "./ChatPage.vue?vue&type=style&index=0&id=1810e656&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1810e656"]])

export default __exports__